import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";

const CompanySelectorDialog = ({ open, onClose, onConfirm }) => {
  const [selectedType, setSelectedType] = useState("");

  return (
    <Dialog
      open={open}
      //onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#f5f9ff",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#1976d2" }}>
          Select Your Firm Type
        </Typography>
        {/* <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton> */}
      </DialogTitle>

      {/* Body */}
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
          Since your entity is classified as <strong>Non Company</strong>,
          please choose your firm type to proceed.
        </Typography>

        <RadioGroup
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <motion.div whileHover={{ scale: 1.02 }}>
            <Card
              variant="outlined"
              sx={{
                mb: 2,
                borderRadius: 3,
                border:
                  selectedType === "partnership_firm"
                    ? "2px solid #1976d2"
                    : "1px solid #ddd",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onClick={() => setSelectedType("partnership_firm")}
            >
              <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <BusinessIcon sx={{ color: "#1976d2", mr: 2 }} />
                <FormControlLabel
                  value="partnership_firm"
                  control={<Radio />}
                  label={
                    <Typography sx={{ fontWeight: 500 }}>
                      Partnership Firm
                    </Typography>
                  }
                />
              </CardContent>
            </Card>
          </motion.div>
          <motion.div whileHover={{ scale: 1.02 }}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 3,
                border:
                  selectedType === "propreitorship_firm"
                    ? "2px solid #1976d2"
                    : "1px solid #ddd",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onClick={() => setSelectedType("propreitorship_firm")}
            >
              <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <StoreIcon sx={{ color: "#1976d2", mr: 2 }} />
                <FormControlLabel
                  value="propreitorship_firm"
                  control={<Radio />}
                  label={
                    <Typography sx={{ fontWeight: 500 }}>
                      Proprietorship Firm
                    </Typography>
                  }
                />
              </CardContent>
            </Card>
          </motion.div>
        </RadioGroup>
      </DialogContent>

      <Divider />

      {/* Footer */}
      <DialogActions sx={{ p: 2 }}>
        {/* <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button> */}
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            bgcolor: "#1976d2",
            "&:hover": { bgcolor: "#125aa2" },
          }}
          disabled={!selectedType}
          onClick={() => {
            onConfirm(selectedType);
            onClose();
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanySelectorDialog;
